import clsx from "clsx";
import { type FC } from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

/** Toggle-chip picker for an insurance package's payor types. */
export const PayorTypeMultiSelect: FC<{
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}> = ({ options, selected, onToggle }) => (
  <div className="mb-4">
    <label className="mb-1 block text-xs font-medium text-text-secondary">Payor types</label>
    <div className="flex flex-wrap gap-2">
      {options.map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => onToggle(value)}
          className={clsx(
            "rounded-full border px-3 py-0.5 text-xs",
            selected.includes(value)
              ? "border-globemallow-600 bg-globemallow-600 text-white"
              : "border-border-medium bg-bg-default text-text-secondary hover:border-globemallow-600",
          )}
        >
          {value}
        </button>
      ))}
      {options.length === 0 && <Small colorType="secondary">No payor types available.</Small>}
    </div>
  </div>
);
